import React from 'react';
import PropTypes from 'prop-types';
import { captureException, showReportDialog } from '@sentry/browser';

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    showDialog: PropTypes.bool,
  };

  static defaultProps = {
    showDialog: false,
  };

  componentDidCatch(err) {
    captureException(err);
    if (this.props.showDialog) {
      showReportDialog();
    }
  }

  render() {
    return this.props.children;
  }
}
